import React from 'react';
import { Button, Tooltip } from 'antd';

export const IconButton = ({allowHover, ...props}) => {

    return (
        <>
            <Tooltip title={props.tooltip || undefined} align={props.align || undefined}>
                <Button className={`${props?.className } ${allowHover && 'btn--hover'}`} {...props}><span className='btn--hover-text'>{props.children}</span></Button>
            </Tooltip>
        </>
    )
}

IconButton.defaultProps = {
    allowHover: true,
}